import { render, staticRenderFns } from "./ftp.vue?vue&type=template&id=4fff53f8&scoped=true&"
import script from "./ftp.vue?vue&type=script&lang=js&"
export * from "./ftp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff53f8",
  null
  
)

export default component.exports